export const formRegEx = /([a-z])([A-Z])/g;
export const formRegExReplacer = "$1 $2";
export const numberRegEx = /[^0-9]+/g;
export const pointRegEx = /^\d*(\.\d{0,2})?$/;
export const floatRegEx = /^\d+\.?\d*$/;
